var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerExploreAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "32px",
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9%",
    y1: "99.291%",
    x2: "49.9%",
    y2: "2.828%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.478 0A3.479 3.479 0 0 0 0 3.48v18.755a3.479 3.479 0 0 0 3.478 3.48h4.893c.515 0 1 .24 1.313.648l2.52 3.291a.881.881 0 0 0 1.403-.004l2.477-3.279a1.654 1.654 0 0 1 1.32-.656h4.822a3.479 3.479 0 0 0 3.478-3.48V3.48A3.479 3.479 0 0 0 22.226 0H3.478z",
    stroke: "#ea0043",
    fill: "#FFFFFF",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.939 17.149a4.69 4.69 0 0 0-.905-2.894L9 12.843l1.503-.465a4.698 4.698 0 0 0 2.544-1.92L14 9l.951 1.458a4.698 4.698 0 0 0 2.545 1.92l1.503.465-1.034 1.412a4.69 4.69 0 0 0-.905 2.894L17.107 19l-1.463-.546a4.7 4.7 0 0 0-3.29 0L10.89 19l.049-1.851z",
    fill: "#ea0043"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerExploreAlt);
export default __webpack_public_path__ + "static/media/MapMarkerExploreAlt.8650cfa3.svg";
export { ForwardRef as ReactComponent };